import { defineMessages } from 'react-intl';

const translations = {
  bulkActions: {
    packing: {
      id: 'actions.packing',
      defaultMessage: 'Packing',
      description: 'Label of the bulk action on the packing page when outbound',
    },
    unpacking: {
      id: 'actions.unpacking',
      defaultMessage: 'Unpacking',
      description: 'Label of the bulk action on the packing page when inbound',
    },
  },
  itemQuantityDialog: {
    packTitle: {
      id: 'packing.itemQuantityDialog.packTitle',
      defaultMessage: 'Packing',
      description: 'Title of the item quantity dialog on the packing page when outbound',
    },
    unpackTitle: {
      id: 'packing.itemQuantityDialog.unpackTitle',
      defaultMessage: 'Unpacking',
      description: 'Title of the item quantity dialog on the packing page when inbound',
    },
    quantityCounter: {
      quantity: {
        id: 'properties.quantity',
        defaultMessage: 'Quantity',
        description: 'Label of the quantity counter quantity field',
      },
      pack: {
        id: 'properties.pack',
        defaultMessage: 'Pack',
        description: 'Label of the quantity counter pack field',
      },
      unpack: {
        id: 'properties.unpack',
        defaultMessage: 'Unpack',
        description: 'Label of the quantity counter unpack field',
      },
    },
  },
  progressDialog: {
    packingMessage: {
      id: 'packing.progressDialog.packingMessage',
      defaultMessage: 'Packing items',
      description: 'Title of the progress dialog for packing action',
    },
    unpackingMessage: {
      id: 'packing.progressDialog.unpackingMessage',
      defaultMessage: 'Unpacking items',
      description: 'Title of the progress dialog for unpacking action',
    },
  },
  remainingItemsDialog: {
    title: {
      id: 'packing.remainingItemsDialog.title',
      defaultMessage: 'Remaining items',
      description: 'Title of the remaining items dialog',
    },
    descriptionPacking: {
      id: 'packing.remainingItemsDialog.descriptionPacking',
      defaultMessage: 'There are still items remaining to be packed. Want to finish anyway?',
      description: 'Description of the remaining items dialog when packing',
    },
    descriptionUnpacking: {
      id: 'packing.remainingItemsDialog.descriptionUnpacking',
      defaultMessage: 'There are still items remaining to be unpacked. Want to finish anyway?',
      description: 'Description of the remaining items dialog when unpacking',
    },
    buttons: {
      cancel: {
        id: 'actions.cancel',
        defaultMessage: 'Cancel',
        description: 'Label of the cancel button of the remaining items dialog',
      },
      finish: {
        id: 'actions.finish',
        defaultMessage: 'Finish',
        description: 'Label of the finish button of the remaining items dialog',
      },
    },
  },
  feedback: {
    addItemsToParcelFailed: {
      id: 'packing.feedback.addItemsToParcelFailed',
      defaultMessage: 'Could not add items to parcel',
      description: 'Error message of the add items to parcel action',
    },
    multipleItemsPacked: {
      id: 'packing.feedback.multipleItemsPacked',
      defaultMessage: 'Items packed',
      description: 'Success message of the pack multiple items action',
    },
    multipleItemsNotPacked: {
      id: 'packing.feedback.multipleItemsNotPacked',
      defaultMessage: 'Items could not be packed',
      description: 'Error message of the pack multiple items action',
    },
    multipleItemsUnpacked: {
      id: 'packing.feedback.multipleItemsUnpacked',
      defaultMessage: 'Items unpacked',
      description: 'Success message of the unpack multiple items action',
    },
    multipleItemsNotUnpacked: {
      id: 'packing.feedback.multipleItemsNotUnpacked',
      defaultMessage: 'Items could not be unpacked',
      description: 'Error message of the unpack multiple items action',
    },
    reportMissingItemsRequestFailed: {
      id: 'packing.feedback.reportMissingItemsRequestFailed',
      defaultMessage: 'Reporting missing items failed',
      description: 'Error message of the report missing items action',
    },
  },
};

export default defineMessages(translations);
